"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_redux_1 = require("react-redux");
const MessagesList_1 = __importDefault(require("./MessagesList"));
const Header_1 = __importDefault(require("./Header"));
const Footer_1 = __importDefault(require("./Footer"));
exports.default = react_1.default.memo(MainPanel);
function MainPanel() {
    const showMainWindow = react_redux_1.useSelector((state) => state.chatsState.selectedChatIndex !== null);
    if (!showMainWindow) {
        return react_1.default.createElement("div", null);
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Header_1.default, null),
        react_1.default.createElement(MessagesList_1.default, null),
        react_1.default.createElement(Footer_1.default, null)));
}
